import React from "react";


function Accommodation() {
  return (
    <div>
      <div className="row banner" style={{backgroundImage:'url(./images/accommodation2.png)',backgroundSize:'cover',backgroundPosition:'center'}}></div>
      <div className="container" style={{marginTop:'100px',marginBottom:'100px'}}>
        {/* <h3 style={{fontWeight:'600',fontSize:'15pt',lineHeight:'24pt',color:'maroon'}}>
            Accommodation facility will be <span style={{color:'red',fontSize:'18pt'}}>UNAVAILABLE</span>  in Panchajanyam Guest House, AC Dormitory, Non-AC Dormitory, Nelppura Hall from 15th Nov 2025 to 20th Jan 2026 due to the Murajapam Lakshadeepam Festival
        </h3> */}
        <hr />
        {/* <h3 style={{marginBottom:'25px',fontWeight:'600'}}>Accommodation Facilities available for Devotees</h3> */}
        <div className="row">
            <div className="col-md-8" style={{background:'#fad096',padding:'10px'}}>
                {/* <div className="row" style={{marginBottom:'50px',borderBottom:'1px solid orange',paddingBottom:'15px',paddingTop:'15px',background:'orange'}}>
                    <div className="col-md-7 middle">
                        <p className="enquiry">For Enquiry & Booking</p>                                               
                    </div>
                    <div className="col-md-5 middle">
                        <p className="phone">0471 2472086</p>                                               
                    </div>                                        
                </div> */}
                <div style={{width:'100%',overflow:'auto'}}>
                <table className="table">
                    <tr style={{background:'maroon'}}>
                        <th>Sl No.</th>
                        <th>Place</th>
                        <th>Rate per Person/24 Hrs(with Bed) (1 bed, 2 bed sheet, 1 pillow)</th>
                        <th>Rate per Person/24 Hrs(with Bed) (1 bed, 2 bed sheet, 1 pillow)</th>
                        <th>Maximum No of persons allowed</th>
                    </tr>
                    <tr>
                        <td>1</td>
                        <td>Nelpura Hall (wooden floor)</td>
                        <td>Rs. 250/-per person</td>
                        <td>Rs. 200/-per person</td>
                        <td>150</td>
                    </tr>
                    <tr>
                        <td>2</td>
                        <td>Nelpura front (Marble floor) Mugappu</td>
                        <td>Rs. 250/-per person</td>
                        <td>Rs. 200/-per person</td>
                        <td>40</td>
                    </tr>
                    <tr>
                        <td>3</td>
                        <td>Old Store Room</td>
                        <td>Rs. 250/-per person</td>
                        <td>Rs. 200/-per person</td>
                        <td>10</td>
                    </tr>
                    <tr>
                        <td>4</td>
                        <td>Upstairs Hall</td>
                        <td>Rs. 250/-per person</td>
                        <td>Rs. 200/-per person</td>
                        <td>20</td>
                    </tr>
                    <tr>
                        <td>5</td>
                        <td>Front Hall</td>
                        <td>Rs. 250/-per person</td>
                        <td>Rs. 200/-per person</td>
                        <td>50</td>
                    </tr>
                </table>
                </div>
                
                
                
                
           </div> 
           <div className="col-md-4" style={{backgroundImage:'url(./images/event.jpeg)',backgroundSize:'cover',backgroundPosition:'center'}}></div>           
        </div>
        
        
      </div>
    </div>
  );
}

export default Accommodation;